import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ALLOWED_IMAGE_TYPE } from '../../constants/constants';
import { MediaCategory } from '../../enums/enums';
import { MediaSignedUrlModel } from '../../interface/interface';
import { SharedService } from '../../services/shared.service';
import { SharedModule } from '../../shared.module';
import { SkeletonLoaderComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-upload-image',
  standalone: true,
  imports: [SkeletonLoaderComponent, SharedModule],
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.scss',
})
export class UploadImageComponent {
  allowedImageType = ALLOWED_IMAGE_TYPE.join(',');
  imageUploading = false;
  @Output() uploadStart: EventEmitter<void> = new EventEmitter();
  @Output() uploadEnd: EventEmitter<MediaSignedUrlModel | null> =
    new EventEmitter();
  @Output() removeImage: EventEmitter<void> = new EventEmitter();
  @Input() previewUrl: string = '';

  constructor(
    private toastr: ToastrService,
    private sharedService: SharedService
  ) {}

  onFileSelction = async (event: any) => {
    const file: File = event?.target?.files?.[0];
    if (file) {
      if (file.size > 1024 * 1024) {
        this.toastr.error('File size must be less than 1 MB');
        return;
      }
      if (!ALLOWED_IMAGE_TYPE.includes(file.type)) {
        this.toastr.error('Please enter a valid image');
        return;
      }
      this.uploadStart.emit();
      this.imageUploading = true;
      this.sharedService
        .getMediaSignedUrl({
          fileName: file.name,
          contentType: file.type,
          category: MediaCategory.IMAGE,
        })
        .subscribe({
          next: (data: MediaSignedUrlModel) => {
            this.sharedService.uploadFile(data.uploadUrl, file).subscribe({
              next: () => {
                this.imageUploading = false;
                this.uploadEnd.emit(data);
              },
              error: (err) => {
                this.uploadEnd.emit(null);
                this.imageUploading = false;
                this.toastr.error(
                  err?.error?.message || err?.message || 'Something went wrong!'
                );
              },
            });
          },
          error: (err) => {
            this.uploadEnd.emit(null);
            this.imageUploading = false;
            this.toastr.error(
              err?.error?.message || err?.message || 'Something went wrong!'
            );
          },
        });
    }
  };

  handleRemoveImage() {
    this.removeImage.emit();
  }
}
